import { Directory } from "../../../../../../base/domain/drawing";
import { EditableFormatSummary, IEditableFormatTreeRepository } from "../../../../../domain/editableFormat";
import { IEditableFormatTreeSource } from "./IEditableFormatTreeSource";
import { SourceProcessorBase } from "./SourceProcessorBase";

export class FormatTreeSourceBase extends SourceProcessorBase<IEditableFormatTreeRepository> implements IEditableFormatTreeSource {
  constructor(public readonly entityName: string, createSource: () => IEditableFormatTreeRepository) {
    super(createSource);
  }

  getTree(): Promise<Directory<number, EditableFormatSummary>[]> {
    return this.doAsync(async t => t.getFormatTree(), "Tree取得");
  }

  addDirectory(name: string, parent: number, index: number): Promise<number> {
    return this.doAsync(async t => t.addDirectory(name, parent, index), "Treeディレクトリ追加");
  }

  moveDirectory(id: number, parent: number, index: number): Promise<void> {
    return this.doAsync(async t => t.moveDirectory(id, parent, index), "Treeディレクトリ移動");
  }

  deleteDirectory(id: number): Promise<void> {
    return this.doAsync(async t => t.deleteDirectory(id), "Treeディレクトリ削除");
  }

  renameDirectory(id: number, name: string): Promise<void> {
    return this.doAsync(async t => t.renameDirectory(id, name), "Treeディレクトリ名称変更");
  }

  addEntity(id: number, name: string, parent: number, index: number): Promise<void> {
    return this.doAsync(async t => t.addFormat(id, name, parent, index), "Treeフォーマット追加");
  }

  moveEntity(id: number, parent: number, index: number): Promise<void> {
    return this.doAsync(async t => t.moveFormat(id, parent, index), "Treeフォーマット移動");
  }

  deleteEntity(id: number): Promise<void> {
    return this.doAsync(async t => t.deleteFormat(id), "Treeフォーマット削除");
  }

  renameEntity(id: number, name: string): Promise<void> {
    return this.doAsync(async t => t.renameFormat(id, name), "Treeフォーマット名称変更");
  }
}
